import * as yup from 'yup';
import { fieldRequired, maxLength, validEmail } from '../../../constants';

export const contactValidation = yup.object().shape({
  cntKey: yup
    .string()
    .nullable()
    .required(fieldRequired)
    .max(50, `${maxLength} 50`),
  honorific: yup.string().nullable().max(50, `${maxLength} 50`),
  firstName: yup.string().nullable().max(50, `${maxLength} 50`),
  suffix: yup.string().nullable().max(50, `${maxLength} 50`),
  middleName: yup.string().nullable().max(50, `${maxLength} 50`),
  lastName: yup.string().nullable().max(50, `${maxLength} 50`),
  address1: yup.string().nullable().max(50, `${maxLength} 50`),
  address2: yup.string().nullable().max(50, `${maxLength} 50`),
  city: yup.string().nullable().max(50, `${maxLength} 50`),
  state: yup.string().nullable().max(50, `${maxLength} 50`),
  zip: yup.string().nullable().max(10, `${maxLength} 10`),
  networkUserName: yup.string().nullable().max(50, `${maxLength} 50`),
  phone: yup.string().nullable().max(20, `${maxLength} 20`),
  fax: yup.string().nullable().max(20, `${maxLength} 20`),
  email: yup.string().nullable().email(validEmail).max(50, `${maxLength} 50`),
  cntName: yup.string().nullable().max(50, `${maxLength} 50`),
  cntMailAdrPrefix: yup.string().nullable().max(50, `${maxLength} 50`),
  cntMailAdr: yup.string().nullable().max(50, `${maxLength} 50`),
  cntOrgId: yup.string().required(fieldRequired),
  title: yup.string().nullable().max(50, `${maxLength} 50`),
  directPhone: yup.string().nullable().max(20, `${maxLength} 20`),
  comment: yup.string().nullable().max(256, `${maxLength} 256`),
});
